// extracted by mini-css-extract-plugin
module.exports = {"dropZone":"navigation-new_dropZone_2fp","hover":"navigation-new_hover__wx","disabled":"navigation-new_disabled_3pY"};